<template>
  <v-menu
    bottom
    left
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-badge
          bordered
          color="red"
          overlap
        >
          <template v-slot:badge>
            <span>{{ notifications.length }}</span>
          </template>

          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list
      flat
      nav
    >
      <app-bar-item
        v-for="(n, i) in notifications"
        :key="i"
        link
      >
        <v-list-item-content>
          <router-link
            :to="{name:'UserProfile'}"
            style="text-decoration: none;color: #000;"
          >
            <v-list-item-title>{{ n }} </v-list-item-title>
          </router-link>
        </v-list-item-content>
      </app-bar-item>
    </v-list>
  </v-menu>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'DefaultNotifications',

    data: () => ({
      notifications: [],
    }),

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取用户列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/notify')
          .then(response => {
            if (response.status === 200) {
              const items = []
              response.data.data.data.map((item, i, arr) => {
                const company = item.company ? item.company : item.description
                items[i] = company + ' 截止时间:' + item.end_at
              })
              this.notifications = items
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
    },

  }
</script>
